import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../src/assets/scss/menu.css";
import { logoutAPI } from "../services/UserService";
import Logo from "../assets/images/avatarUser.svg";
import { PiListMagnifyingGlassBold } from "react-icons/pi";

import { FiChevronsLeft } from "react-icons/fi";

import { TbReportMoney } from "react-icons/tb";
import { TbLogout } from "react-icons/tb";

const Sidebar = ({ isOpen, onClose }) => {
    const nav = useNavigate();
    const location = useLocation();
    const [userName, setUserName] = useState("");
    const token = localStorage.getItem("token");
    const showExpense = localStorage.getItem("showExpense");


    useEffect(() => {
        const name = localStorage.getItem("userName") || "";
        setUserName(name);
    }, []);

    const logout = () => {
        logoutAPI(token).then((r) => console.log(r));
        localStorage.clear();
        nav("/login");
    };

    return (
        <>
            <div className={`sidebar ${isOpen ? "open" : ""}`}>
                <div>
                    <div className="sidebar-top">
                        <img src={Logo} alt="User Avatar" width={40} height={40} />
                        <span className="username">{userName}</span>
                        <FiChevronsLeft className="toggle-btn" size={20} strokeWidth={2} onClick={onClose} />
                    </div>
                    <div className="sidebar-menu">
                        <div
                            className={`menu-item ${location.pathname === "/" ? "custom-btn-primary" : ""}`}
                            onClick={() => nav("/")}
                        >
                            <PiListMagnifyingGlassBold size={22} className="me-2" />
                            Tra cứu vận chuyển
                        </div>
                        {showExpense === "1" && <div
                            className={`menu-item ${location.pathname === "/bang-ke" ? "custom-btn-primary" : ""}`}
                            onClick={() => nav("/bang-ke")}
                        >
                            <TbReportMoney size={22} className="me-2" />
                            Bảng kê chi phí
                        </div>}
                        <div onClick={logout} className="menu-item">
                            <TbLogout size={22} className="me-2" />
                            Đăng xuất
                        </div>
                    </div>
                </div>
                <div>
                    <div className="sidebar-footer">© {new Date().getFullYear()} An Hoa Phu Transport</div>
                    <div className="sidebar-footer">
                        Hotline: <a href="tel:0906684184" style={{ color: '#0d6efd', textDecoration: 'none' }}>0906 684 184</a>
                    </div>
                </div>

                {/*  */}
            </div>
            {isOpen && <div className="sidebar-backdrop" onClick={onClose}></div>}
        </>
    );
};

export default Sidebar;
